module.exports = __webpack_public_path__ + "img/area-2.493c372b.png";